// extracted by mini-css-extract-plugin
module.exports = {"modalReview":"style_modalReview__F39Jw","title":"style_title__2g5id","modalButtons":"style_modalButtons__26jmZ","button":"style_button__2Zxs1"};